const ClubMembersMain = () => import(/*webpackChunkName: 'club-members'*/ '@/views/ClubMembers.vue');
const ClubMembers = () => import(/*webpackChunkName: 'club-members'*/ '@/components/club-members/ClubMembers.vue');
const ClubMembersEditMember = () =>
    import(/*webpackChunkName: 'club-members'*/ '@/components/club-members/ClubMembersEditMember.vue');
import { ROUTES_CLUB_MEMBERS, ROUTES_EDIT_CLUB_MEMBER_ROLES } from '@/constants/routes';

export default {
    path: '/club-members',
    name: 'club-members-main',
    component: ClubMembersMain,
    children: [
        {
            path: '/club-members',
            name: ROUTES_CLUB_MEMBERS,
            component: ClubMembers
        },
        {
            path: '/club-members/edit',
            name: ROUTES_EDIT_CLUB_MEMBER_ROLES,
            component: ClubMembersEditMember
        }
    ]
};
